<template>
  <div>
    <van-search
      v-model="searchString"
      show-action
      placeholder="请输入收款方"
      @search="getReceivablesList"
      @cancel="cancelSearch"
    />
    <van-row class="filter-nav">
      <van-col :span="8">收款类别
        <van-icon name="arrow"/>
      </van-col>
      <van-col :span="8">状态
        <van-icon name="arrow"/>
      </van-col>
      <van-col :span="8" @click="showFilterPanel=true">筛选
        <van-icon name="arrow"/>
      </van-col>
    </van-row>
    <ul class="record-list">
      <li class="record-item" v-for="(item,i) in payList" :key="i">
        <van-row class="mt10 text-lightgray" type="flex" align="center" justify="center" :gutter="5">
          <van-col :span="9" class="h4 text-muted">{{item.RPerName}}</van-col>
          <van-col :span="9" class="text-center">总金额：<span
            class="text-muted">{{currencycon(item.SumAmount,'',2)}}</span></van-col>
          <van-col :span="2" class="text-center">{{item.Currency}}</van-col>
          <van-col :span="4" class="text-right">{{item.Record}}</van-col>
        </van-row>
        <van-row class="mt10">
          <van-col :span="10" class="text-lightgray">收款日期：{{item.Date}}</van-col>
          <van-col :span="14" class="text-right">
            <span class="text-primary">反销账</span>
            <span class="ml10 text-primary" @click="editRecord(item)">编辑</span>
            <span class="ml10 text-danger" @click="delRecord(item)">删除</span>
            <span class="ml10 text-primary" @click="voucher(item.RP_GUID)">凭证</span>
          </van-col>
        </van-row>
      </li>
    </ul>
    <!--    <div id="bothbox">-->
    <!--      <div class="boxcon">-->
    <!--        <li class="incon1">-->
    <!--          <input class="js-startdate-picker" type="text" placeholder="收款日期" v-model="selectBirthDate" readonly>-->
    <!--          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>-->
    <!--        </li>-->
    <!--        <li class="incon1">-->
    <!--          <input class="js-enddate-picker" type="text" placeholder="结束时间" v-model="enddate" readonly>-->
    <!--          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>-->
    <!--        </li>-->
    <!--        <li class="incon2">-->
    <!--          <input type="text" placeholder="收款类别" id="btncon" @click="toShow" ref="incomeGrp" readonly>-->
    <!--          <vue-pickers-->
    <!--            :show="show"-->
    <!--            :columns="columns"-->
    <!--            :defaultData="defaultData"-->
    <!--            :selectData="pickData"-->
    <!--            @cancel="close"-->
    <!--            @confirm="confirmFn"></vue-pickers>-->
    <!--        </li>-->
    <!--        <li class="incon2">-->
    <!--          <input type="text" placeholder="收款子类别" readonly>-->
    <!--        </li>-->
    <!--        <li class="incon2">-->
    <!--          <input type="text" placeholder="付款方" id="btncon1" @click="toCus" ref="customer" readonly>-->
    <!--          <vue-pickers-->
    <!--            :show="isshow"-->
    <!--            :columns="columns"-->
    <!--            :selectData="customercon"-->
    <!--            @cancel="close1"-->
    <!--            @confirm="concus">-->
    <!--          </vue-pickers>-->
    <!--        </li>-->
    <!--        <li class="incon2">-->
    <!--          <input type="text" placeholder="销账状态" id="btncon3" @click="tostate" ref="state" readonly>-->
    <!--          <vue-pickers-->
    <!--            :show="isshow3"-->
    <!--            :columns="columns"-->
    <!--            :selectData="statecon"-->
    <!--            @cancel="close3"-->
    <!--            @confirm="stateCon">-->
    <!--          </vue-pickers>-->
    <!--        </li>-->
    <!--      </div>-->
    <!--      <div class="footbot">-->
    <!--        <p id="Reset">重置</p>-->
    <!--        <p id="confirm" @click="btn()">确定</p>-->
    <!--      </div>-->
    <!--    </div>-->
    <van-dialog v-model="showVoucher" title="凭证查看">
      <div style="padding:1rem">
        <van-row class="h6">
          <van-col :span="12">核算单位：{{userName}}</van-col>
          <van-col :span="12" class="text-right">日期：{{datecon.slice(0,11)}}</van-col>
        </van-row>
        <van-row class="h6 mt10">
          <van-col :span="6">摘要</van-col>
          <van-col :span="5">会计科目</van-col>
          <van-col :span="5">二级科目</van-col>
          <van-col :span="4">借方金额</van-col>
          <van-col :span="4">贷方金额</van-col>
        </van-row>
        <van-row class="voucher-item" v-for="(item,i) in sectioncon" :key="i">
          <van-col :span="6">{{item.Summary}}</van-col>
          <van-col :span="5">{{item.Name}}</van-col>
          <van-col :span="5">{{item.ThName===null?item.DetailName:item.DetailName+'-'+item.ThName}}</van-col>
          <van-col :span="4">{{currencycon(item.DebitAmount===0?'':item.DebitAmount,'',2)}}</van-col>
          <van-col :span="4">{{currencycon(item.CreditAmount===0?'':item.CreditAmount,'',2)}}</van-col>
        </van-row>
        <van-row class="h6 mt10">
          <van-col :span="16">{{numToCny(DebitsAmount)}}</van-col>
          <van-col :span="4">{{currencycon(DebitsAmount,'',2)}}</van-col>
          <van-col :span="4">{{currencycon(CreditsAmount,'',2)}}</van-col>
        </van-row>
        <van-row class="h6 mt10">
          <van-col :span="8">财务主管：{{userName}}</van-col>
          <van-col :span="8">记账：{{userName}}</van-col>
          <van-col :span="8">复核：{{userName}}</van-col>
        </van-row>
        <van-row class="mt10 h6">
          <van-col :span="8">出纳：{{userName}}</van-col>
          <van-col :span="8">制单：{{userName}}</van-col>
          <van-col :span="8">经办人：{{userName}}</van-col>
        </van-row>
      </div>
    </van-dialog>
    <van-popup v-model="showFilterPanel" position="right" :style="{ height: '100%',width:'80%' }">
      <h2>条件筛选</h2>
      <!--      <ul>-->
      <!--        <li class="incon1">-->
      <!--          <input class="js-startdate-picker" type="text" placeholder="付款日期" v-model="selectBirthDate" readonly>-->
      <!--          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>-->
      <!--        </li>-->
      <!--        <li class="incon1">-->
      <!--          <input class="js-enddate-picker" type="text" placeholder="结束时间" v-model="enddate" readonly>-->
      <!--          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>-->
      <!--        </li>-->
      <!--        <li class="incon2">-->
      <!--          <input type="text" placeholder="付款类别" id="btncon" @click="toShow" ref="incomeGrp" readonly>-->
      <!--          <vue-pickers-->
      <!--            :show="show"-->
      <!--            :columns="columns"-->
      <!--            :defaultData="defaultData"-->
      <!--            :selectData="pickData"-->
      <!--            @cancel="close"-->
      <!--            @confirm="confirmFn"></vue-pickers>-->
      <!--        </li>-->
      <!--        <li class="incon2">-->
      <!--          <input type="text" placeholder="付款子类别" readonly>-->
      <!--        </li>-->
      <!--        <li class="incon2">-->
      <!--          <input type="text" placeholder="收款方" id="btncon1" @click="toCus" ref="customer" readonly>-->
      <!--          <vue-pickers-->
      <!--            :show="isshow"-->
      <!--            :columns="columns"-->
      <!--            :selectData="customercon"-->
      <!--            @cancel="close1"-->
      <!--            @confirm="concus">-->
      <!--          </vue-pickers>-->
      <!--        </li>-->
      <!--        <li class="incon2">-->
      <!--          <input type="text" placeholder="销账状态" id="btncon3" @click="tostate" ref="state" readonly>-->
      <!--          <vue-pickers-->
      <!--            :show="isshow3"-->
      <!--            :columns="columns"-->
      <!--            :selectData="statecon"-->
      <!--            @cancel="close3"-->
      <!--            @confirm="stateCon">-->
      <!--          </vue-pickers>-->
      <!--        </li>-->
      <!--      </ul>-->
      <van-row class="filter-btns">
        <van-col :span="12">
          <van-button block>重置</van-button>
        </van-col>
        <van-col :span="12">
          <van-button type="primary" block @click="btn()">确定</van-button>
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
  import vuePickers from 'vue-pickers'
  import {getALLVoucherFun, getReceivablesListFun, delReceivablesRecordFun} from "@/api/payment";
  import {Dialog} from 'vant'

  export default {
    name: "findrecord",
    components: {
      vuePickers
    },
    data() {
      return {
        searchString: '',//搜索的内容
        showFilterPanel: false,//是否显示右侧过滤面板
        showVoucher: false,//查看凭证
        payList: [],
        userName: this.getCookie('UserInfo').NickName || '',
        //==========================================//
        sectioncon: [],
        section: [],
        Bookkeeping: '',
        making: '',
        Accounting: '',
        datecon: '',
        DebitsAmount: '',
        CreditsAmount: '',
        show: false,
        isshow: false,
        isshow3: false,
        columns: 1,
        isCopy: '',
        defaultData: [
          {
            text: '全部',
            value: '全部'
          }
        ],
        pickData: {
          // 第一列的数据结构
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '未归类',
              value: '未归类'
            },
            {
              text: '内部转账',
              value: '内部转账'
            },
            {
              text: '经营活动收款',
              value: '经营活动收款'
            },
            {
              text: '投资活动收款',
              value: '投资活动收款'
            },
            {
              text: '筹资活动收款',
              value: '筹资活动收款'
            },
          ]
        },
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        statecon: {
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '未销账',
              value: '未销账'
            },
            {
              text: '已销账',
              value: '已销账'
            }
          ]
        },
        res: null,
        enddate: '',
        selectBirthDate: '',
        currencyList: [],
        stateList: ['全部', '应付', '已付'],
        customerList: [],
        costList: [],
        collectionList: []
      }
    },
    mounted() {
      this.getCustomer();
      this.getReceivablesList()
    },
    methods: {
      //获取到付款的全部数据
      async getReceivablesList() {
        let params = {
          pageSize: 100,
          pageIndex: 1,
          C_GUID: this.getCookie('CompanyInfo').companyId,
          record: '',
          dateBegin: '',
          dateEND: '',
          customer: '',
          incomeGrp: '',
          InvTypeDts: '',
          RP_GUID: '',
          customerName: this.searchString
        };
        let response = await getReceivablesListFun(params);
        if (response.success) {
          console.log(response);
          this.payList = response.result
        }
      },
      //取消搜索
      cancelSearch() {
        this.searchString = '';
        this.getReceivablesList()
      },
      //凭证获取按钮
      async voucher(RP_GUID) {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId,
          Date: '',
          M_GUID: RP_GUID,
          VouchGuid: ''
        };
        let response = await getALLVoucherFun(params);
        if (response.success) {
          this.datecon = response.result[0].Date.replace(/-/g, "/").replace(/-/g, "/").replace(/-/g, "")
          this.sectioncon = response.result;
          this.section = this.sectioncon.pop()
          this.DebitsAmount = JSON.stringify(this.section.DebitAmount)
          this.CreditsAmount = JSON.stringify(this.section.CreditAmount)
          this.showVoucher = true;
        }
      },
      //  删除
      delRecord(record) {
        Dialog.confirm({
          message: '确定删除该记录吗？',
        }).then(async () => {
          const params = {
            GUID: record.RP_GUID,
            C_GUID: this.getCookie('CompanyInfo').companyId,
          };
          const response = await delReceivablesRecordFun(params);
          if (response.success) {
            this.getPaymentRecord();
          }
        })
      },
      //编辑
      editRecord(record) {
        this.$router.push(`/collection/mark/${record.RP_GUID}`)
      },
      searchcon() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/ReceivablesRecord/GetReceivablesList',
          data: this.$qs.stringify({
            pageSize: '',
            pageIndex: '',
            C_GUID: sessionStorage.getItem('companyId'),
            record: '',
            dateBegin: '',
            dateEND: '',
            customer: '',
            incomeGrp: '',
            InvTypeDts: '',
            RP_GUID: '',
            customerName: this.$refs.inputcon.value,
          })
        }).then(res => {
          this.collectionList = res.data.result
          this.$refs.inputcon.value = ''
          console.log(this.collectionList)
        })
      },
      //查询收款页面
      //获取收款的每一条数据并进行页面跳转
      GetbothReceivablesList(i) {
        this.$axios({
          method: 'post',
          url: '/fmsapi/ReceivablesRecord/GetReceivablesList',
          data: this.$qs.stringify({
            pageSize: '-1',
            pageIndex: '1',
            C_GUID: sessionStorage.getItem('companyId'),
            record: '',
            dateBegin: '',
            dateEND: '',
            customer: '',
            incomeGrp: '',
            InvTypeDts: '',
            RP_GUID: '',
          })
        }).then(res => {
          this.collectionList = res.data.result
          console.log(res.data)
          console.log(res.data.result[i].RP_GUID)
          sessionStorage.setItem('RP_GUID', res.data.result[i].RP_GUID)
          sessionStorage.setItem('RPerdetaName', res.data.result[i].RPerName === null ? '' : res.data.result[i].RPerName)
          sessionStorage.setItem('RPercon', res.data.result[i].RPer)
          this.$router.push({path: '/Dection'})
        })
      },
      //收款类别的选择
      confirmFn(val) {
        var btn = document.getElementById('btncon')
        console.log(val.select1.value)
        this.show = false
        btn.value = val.select1.value
        this.res = btn.value
        // console.log(JSON.parse(this.defaultData))
        this.defaultData = [val.select1[0]]
      },
      //收款方的选择
      concus(val) {
        var btn2 = document.getElementById('btncon1')
        console.log(val.select1.value)
        this.isshow = false
        btn2.value = val.select1.value
        this.res = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      //状态的选择
      stateCon(val) {
        var btn4 = document.getElementById('btncon3')
        this.isshow3 = false
        btn4.value = val.select1.value
        this.res = btn4.value
        // console.log(JSON.parse(this.defaultData))
      },
      //点击筛选的按钮显示
      screen() {
        var bothbox = document.getElementById('bothbox');
        var boxcon1 = document.getElementById("boxcon1")
        bothbox.style.transform = " translate(0,0)"
        bothbox.style.transitionDuration = "1s"
        boxcon1.style.display = 'block'
      },
      //点击取消按钮
      cancels() {
        this.$refs.inputcon.value = ''
        window.location.reload()
      },
      //获取到所有的货币
      getcurrency() {
        var currency = document.getElementById('currency')
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {
          this.currencyList = res.data.result
          this.currencyCon.data1 = new Array();
          for (var i = 0; i < this.currencyList.length; i++) {
            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})
          }

        })
      },
      //获取所有的收款方
      async getCustomer() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId,
        };
        const response = await getReceivablesListFun(params);
        if (response.success) {

        }
      },
      //转换器
      currencycon(value, currency, decimals) {
        const digitsRE = /(\d{3})(?=\d)/g
        value = parseFloat(value)
        if (!isFinite(value) || (!value && value !== 0)) return ''
        currency = currency != null ? currency : '$'
        decimals = decimals != null ? decimals : 2
        var stringified = Math.abs(value).toFixed(decimals)
        var _int = decimals
          ? stringified.slice(0, -1 - decimals)
          : stringified
        var i = _int.length % 3
        var head = i > 0
          ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
          : ''
        var _float = decimals
          ? stringified.slice(-1 - decimals)
          : ''
        var sign = value < 0 ? '-' : ''
        return sign + currency + head +
          _int.slice(i).replace(digitsRE, '$1,') +
          _float
      },
      //返回到主页
      back() {
        this.$router.push('/home')
      },
      //跳转到申请收入外收款页面
      Dec() {
        this.$router.push({path: '/Dec'})
      },
      //跳转到查询收入外收款
      findrecord() {
        this.$router.push({path: '/findrecord'})
      },
      //跳转到记录付款
      rec() {
        this.$router.push({path: '/Rec'})
      }
    }
  }
</script>

<style lang="less" scoped>
  .filter-nav {
    background: white;
    text-align: center;
    padding: 1rem 0;
    margin-top: 1rem;

    .filter-btns {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .record-list {
    background: white;
    margin-top: 1rem;
    flex: 1;
    overflow: auto;

    .record-item {
      padding: 1rem;
      border-top: solid 1px #f0f0f0;
    }
  }

  .voucher-item {
    font-size: 1.2rem;
    margin-top: 1rem;

    &:nth-child(odd) {
      background: #f0f0f0;
    }
  }

  #Mask {
    position: fixed;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 2;
    display: none;
  }

  #sectioncon {
    width: 35rem;
    padding-bottom: 0.1rem;
    position: fixed;
    z-index: 3;
    top: 203px;
    left: 5px;
    background: white;
    display: block;
  }

  .sectionmaintop {
    height: 3.8rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    color: black;
    font-size: 1rem;
    line-height: 3.8rem;
    font-weight: bold;
    background: #92cddc;
  }

  #sectioncon h2 {
    display: block;
    height: 3.25rem;
    font-size: 1.4rem;
    color: black;
    text-align: center;
    line-height: 3.25rem;
  }

  .sectiontop {
    height: 1.8rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: black;
  }

  .sectiontopconleft, .sectiontopconright {
    display: flex;
    flex-direction: row;
  }

  .maint1 {
    width: 6.7rem;
    text-align: center;
  }

  .maint2 {
    width: 77rem;
    text-align: center;
  }

  .maint3 {
    width: 0.66rem;
    text-align: center;
  }

  .maint4 {
    width: 0.73rem;
    text-align: center;
  }

  .maint5 {
    width: 0.82rem;
    text-align: center;
  }

  .sectionmaintopcon {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    color: black;
    font-size: 0.1rem;
    line-height: 0.37rem;
    height: 0.37rem;
  }

  .sectionmaintopcon1 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    color: black;
    font-size: 1rem;
    line-height: 3.7rem;
    background: #92cddc;
    height: 3.7rem;
  }

  .maintop1 {
    width: 7.7rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .maintop2 {
    width: 7.7rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .maintop3 {
    width: 9.6rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .maintop4 {
    width: 7rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;

  }

  .maintop5 {
    width: 8rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;
  }

  .maintops1 {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .maintops2 {
    width: 7.7rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .maintops3 {
    width: 9.6rem;
    text-align: center;
    border-left: 1px solid #a3d5e1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sectionbot {
    height: 1.8rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    color: black;
  }

  .sectionbot li {
    display: flex;
    flex-direction: row;

  }

  #close {
    background: #92cddc;
    color: white;
    font-size: 1.3rem;
    text-align: center;
    width: 3.5rem;
    height: 2rem;
    margin-left: 3rem;
    margin-top: 0.8rem;
  }

  /*大盒子，首位固定*/
  .bigbox {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;

  }

  .maincon {
    background: white;
    width: 100%;
  }

  #main_con {
    margin: 0 auto;
  }

  /*每个公司的尺寸*/
  #main_con li {
    background: white;
    height: 6.7rem;
    border-bottom: 1px solid #ececec;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }

  #main_con li a {
    display: flex;
    align-items: center;
    color: #09a9bf;
    font-size: 1.5rem;
    width: 5rem;
  }

  #bothmain {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

  .topp1, #botp {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-end;
  }

  #topp {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  #topp {
    height: 3rem;
    margin-top: 10px;

  }

  #topp h2 {
    font-size: 1.5rem;
    color: #000;
    width: 126px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #topp p {
    font-size: 1rem;
    color: #b8b8b8;
    float: left;
    width: 166px;
  }

  #topp p span {
    color: #000;
  }

  #botp {
    height: 1.8rem;
    font-size: 1rem;
    color: #b8b8b8;
  }

  #botp p {
    margin-left: 10px;
  }

  #botp p:first-child {
    margin-left: 0;
  }

  #topp p:last-child span {
    font-size: 1.3rem;
  }

  /*头部固定*/
  header {
    height: 3.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff
  }

  /*头部标题*/
  .head {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 0.13rem;
    color: black;
  }

  /*标题样式*/
  .head h2 {
    display: block;
    width: 25rem;
    text-align: center;
  }

  .head img:last-child {
    width: 1.5rem;
    height: 1.1rem;
  }

  .head img:first-child {
    width: 0.9rem;
    height: 1.7rem;
  }

  section {
    flex: 1;
    overflow: auto;
  }

  .Topmain {
    height: 10rem;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 1.3rem;
    flex-wrap: wrap;
  }

  .Topmain a {
    display: block;
    width: 10rem;
    height: 3.3rem;
    background: white;
    border-radius: 8px;
    color: black;
    text-align: center;
    line-height: 3.2rem;
    margin-left: 10px;
  }

  .Topmain a:nth-child(2) {
    background: #09a9bf;
    color: white
  }

  .header {
    height: 8.3rem;
    display: flex;
    flex-direction: column;
    background: white;
    overflow: hidden;
    border-bottom: 1px solid #e0e0e0;
  }

  #search {
    height: 5rem;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .hedT {
    width: 32rem;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 2.2rem;
  }

  .hedT input {
    display: block;
    width: 23rem;
    height: 2.8rem;
    padding-left: 3.3rem;
    border-radius: 20px;
    background: #f1f1f1;
    font-size: 1.2rem;
    margin-left: 1rem;

  }

  .hedT img {
    position: absolute;
    width: 1.3rem;
    height: 1.3rem;
    left: 2rem;
  }

  .hedB {
    display: flex;
    align-items: center;
    width: 3.6rem;
    height: 100%;
    color: black;
    margin-left: 1rem;
  }

  .inCon3 #currency p:last-child {
    text-align: center;
  }

  #choose {
    height: 3.3rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background: white;
    padding: 0 3rem;
  }

  #choose li {
    height: 1.9rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.2rem;
    font-size: 1.4rem;
  }

  #choose li p {
    width: 6rem;
    color: #888888;
    text-align: center;
  }

  #choose li a {
    display: block;
    width: 11px;
    height: 7px;
  }

  #choose li:last-child a {
    display: block;
    width: 1.5rem;
    height: 1.4rem;
  }

  #choose li:nth-child(2) {
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc
  }

  #choose li a img {
    width: 100%;
    height: 100%;
  }

  #bothbox {
    width: 26.8rem;
    position: fixed;
    z-index: 3;
    height: 100%;
    background: white;
    top: 0;
    right: 0;
    transform: translate(26.8rem, 0);
  }

  #bothbox h2 {
    display: block;
    height: 1.4rem;
    line-height: 1.4rem;
    color: #969696;
    margin-left: 1.8rem;
  }

  .title {
    height: 3.9rem;
    font-size: 1.2rem;
    margin-left: 2.3rem;
    line-height: 3.9rem;
    color: black;
  }

  .boxcon {
    padding: 0 1.7rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

  }

  .footbot {
    width: 100%;
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    border-top: 1px solid #ececec;
  }

  #Reset {
    width: 10rem;
    background: white;
    font-size: 1.1rem;
    color: black;
    line-height: 4rem;
    text-align: center;
  }

  #confirm {
    width: 16.5rem;
    background: #08a8be;
    font-size: 1.1rem;
    line-height: 4rem;
    text-align: center;
  }

  .incon1 {
    width: 9.6rem;
    height: 2.4rem;
    background: #f6f6f6;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0.8rem;
    align-items: center;
    margin-left: 5px;
  }

  .incon1 p {
    color: black

  }

  .incon1 a {
    display: block;
    width: 0.9rem;
    height: 0.6rem;
  }

  .incon1 a img {
    width: 100%;
    height: 100%;
  }

  .incon1 input {
    display: block;
    width: 96px;
    height: 26px;
    background: #f6f6f6f6;
  }

  .incon2 {
    width: 7.5rem;
    height: 2.4rem;
    background: #f6f6f6;
    border-radius: 8px;
    margin-top: 10px;
    margin-left: 3px;
  }

  .incon2 input {
    display: block;
    width: 78px;
    margin-left: 4px;
    height: 26px;
    background: #f6f6f6f6;
    text-align: center;
    color: black;
    font-size: 1.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .incon2 a {
    color: black;
    display: block;
    text-align: center;
    line-height: 2.4rem
  }
</style>
